export default __webpack_public_path__ + "static/media/deskera-logo.f58da934.gif";